import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { IconSizesEnum } from '../../../shared/components/icon/icons-sizes.enum';
import { IIcon } from '../../../shared/components/icon/icon.interface';
import { TaskItem } from '../../../home-data/models/submodels/task-item.model';
import { TaskItemStateEnum } from '../../../home-data/home-data.data';
import { TrackingObjectBuilder } from '../../../tracking/tracking-object.builder';
import { I2gNgTrackingActionBuilder } from 'i2g-ng-tracking';
import {
  IFtuAdditionalProperties,
  ITrackingAction,
  ITrackingObject,
  TrackingScreenNamesEnum,
} from '../../../tracking/tracking.data';
import { TrackingAdditionalPropertiesBuilder } from '../../../tracking/tracking-additional-properties.builder';
import { TrackingDispatcher } from '../../../tracking/tracking.dispatcher';

@Component({
  selector: 'app-home-task-list-item',
  templateUrl: './home-task-list-item.component.html',
  styleUrls: ['./home-task-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeTaskListItemComponent implements OnInit {
  @Input() taskItem: TaskItem;
  @Input() trackingScreenName: TrackingScreenNamesEnum;

  @Output()
  taskItemClick: EventEmitter<TaskItem> = new EventEmitter<TaskItem>();
  @Output()
  taskItemDismiss: EventEmitter<TaskItem> = new EventEmitter<TaskItem>();

  taskItemStateIcon: IIcon;
  closeIcon: IIcon;

  private _trackingObject: ITrackingObject;
  private _trackingAdditionalProperties: IFtuAdditionalProperties;

  constructor(
    private _trackingObjectBuilder: TrackingObjectBuilder,
    private _trackingActionBuilder: I2gNgTrackingActionBuilder,
    private _trackingAdditionalPropertiesBuilder: TrackingAdditionalPropertiesBuilder,
    private _trackingDispatcher: TrackingDispatcher
  ) {}

  ngOnInit() {
    this.taskItemStateIcon = {
      name:
        this.taskItem.state === TaskItemStateEnum.completed
          ? 'task-complete'
          : 'task-incomplete',
      size: IconSizesEnum.custom,
    };
    this.closeIcon = {
      name: 'close',
      size: IconSizesEnum.custom,
    };

    this._trackingObject = this._trackingObjectBuilder.buildTask(this.taskItem);
    this._trackingAdditionalProperties = this._trackingAdditionalPropertiesBuilder.buildFtuOptions();
  }

  onTaskItemClick() {
    this.taskItemClick.emit(this.taskItem);
    this._trackTaskItemEvent(
      this._trackingActionBuilder.buildTapped(this.trackingScreenName)
    );
  }

  onTaskItemDismiss() {
    this.taskItemDismiss.emit(this.taskItem);
    this._trackTaskItemEvent(
      this._trackingActionBuilder.buildDeleted(this.trackingScreenName)
    );
  }

  private _trackTaskItemEvent(trackingAction: ITrackingAction) {
    this._trackingDispatcher.trackEvent(
      this._trackingObject,
      trackingAction,
      this._trackingAdditionalProperties
    );
  }
}
